module.exports = __webpack_public_path__ + "static/media/logo.1a2075c8.svg";